export const camera = () => (
  <path
    d="M7 21H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2v11a2 2 0 01-2 2h-4m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
